import ApiService from '../api.services';

const ReverseLogisticsService = {
    add: async function (form) {
        try {
            const data = {
                reverse: form
            }
            const res = await ApiService.post('/api/reverse', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    services: async function (filter) {
        try {
            const res = await ApiService.post(`/api/reverse/services`, filter);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    original: async function (tag) {
        try {
            const res = await ApiService.get(`/api/reverse/original/${encodeURIComponent(tag)}`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    list: async function (filter) {
        try {
            const res = await ApiService.post(`/api/reverse/filter`, filter);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    authorization: async function (id) {
        try {
            const res = await ApiService.get(`/api/reverse/authorization/${id}`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const res = await ApiService.get(`/api/reverse/id/${id}`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    export: async function (data, file) {
        try {
            const res = await ApiService.post(`/api/reverse/export/${file}`, data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const res = await ApiService.delete(`/api/reverse/${id}`);
            return res.data;
        } catch (error) {
            throw error;
        }
    },

};

export default ReverseLogisticsService;

export { ReverseLogisticsService };

